module.exports = __webpack_public_path__ + "img/mp4.8c6d24f3.png";